export default "__VITE_ASSET__5665e721__"